module.exports = __webpack_public_path__ + "static/img/810G5M.24a2d90c.png";